export const PROGRESSIVE_APP_REPORT_LOADINGS = {
  GET_REPORT: "loadingProgressiveAppReport"
};

export const reportProgressiveAppTypes = {
  SET_PROGRESSIVE_APP_REPORT_FILTERS: "PROGRESSIVE_APP_REPORT/SET_FILTERS",
  RESTORE_INITIAL: "PROGRESSIVE_APP_REPORT/RESTORE_INITIAL",
};
